import React, { useCallback, useRef, useState } from "react";
import VimeoPlayer from "react-player/vimeo";
import screenfull from "screenfull";

import "./Video.scss";

export const VIDEO_PADDING_Y = `56.25%`; // for 16/9 ratio

export const VimeoContainer = ({
  className = "",
  url,
  onPlay = () => {},
  onPause = () => {},
  children,
  ...playerProps
}) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const player = useRef();

  const onVideoPlay = useCallback(() => {
    if (screenfull.isEnabled) {
      screenfull.request(player.current.wrapper);
    }
    setVideoPlaying(true);
    onPlay();
  }, [onPlay]);

  const onVideoPause = useCallback(() => {
    setVideoPlaying(false);
    onPause();
  }, [onPause]);

  const onVideoLoad = useCallback(() => {
    setVideoLoaded(true);
  }, []);

  // const [container, bounds] = useMeasure({ polyfill: ResizeObserver });

  return (
    <div
      // ref={container}
      className={`video-player ${className}`}
      style={{
        paddingTop: VIDEO_PADDING_Y,
        // paddingTop: `28.125%`,
        // paddingBottom: `28.125%`,
      }}
    >
      {!videoLoaded ? (
        <div className="video-player__loading">
          <div className="">
            <svg className="" role="img" aria-label="loading symbol">
              <use xlinkHref="#loading-circle" />
            </svg>
          </div>
        </div>
      ) : null}
      <VimeoPlayer
        ref={player}
        onPlay={onVideoPlay}
        onPause={onVideoPause}
        className="video-player__iframe"
        controls
        fullscreen={videoPlaying ? true : undefined}
        onReady={onVideoLoad}
        responsive="true"
        style={{
          visibility: `${videoLoaded ? `visible` : `hidden`}`,
          animation: `${videoLoaded ? `fade-in 1s ease-in` : `none`}`,
        }}
        width={`100%`}
        height={`100%`}
        url={url}
        {...playerProps}
      />
      {videoPlaying ? null : children}
    </div>
  );
};
